import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import { saveItem } from 'state/actions'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'
import { stringIsEmpty } from 'utils/utils'

import InputStandard from 'components/input/standard'

class ModalGroup extends Component {
	state = {
		name: ''
	}

	UNSAFE_componentWillMount(){
		this.setState({
			name: this.props.data.milestone ? this.props.data.milestone.name : ''
		})
	}

	componentDidMount() {
		setTimeout(_ => { 
    		this.refs.milestoneName.inputRef.focus()
    	}, 1)		
	}

	handleChange = e => {
		this.setState({
			name: e.target.value
		})
	}

	saveItem = _ => {
		const {
			isLoading,
			data,
			setLoading,
			saveItem,
			closeCallback,
			handleError,
			operation
		} = this.props

		if(isLoading){
			return 
		}

		if(stringIsEmpty(this.refs.milestoneName.inputRef.value)) {
			handleError("Please enter a milestone name")
			return
		}

		const requestData = {
			name: this.refs.milestoneName.inputRef.value,
			id: data.milestone ? data.milestone.id : null,
			project_id: data.project_id ? data.project_id : null,
			operation
		}

		setLoading(true)

		saveItem(requestData, 'milestone', _ => {
			setLoading(false)
			closeCallback()
		})
	}

	render() {
		return(
			<div>
				<div className={'borders'}>
					<InputStandard 
						outlineOnFocus={true} 
						ref="milestoneName" 
						callback={this.saveItem} 
						value={this.state.name} 
						onChange={this.handleChange} 
						placeholder='E.g "Complete website designs"' 
					/>
				</div>
				<ValidateResponse 
					dismissCallback={this.props.handleDismiss}
					response={this.props.validateResponse} 
				/>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.saveItem} 
					label={'Yep'} 
					icon={'check'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={this.props.closeCallback} 
					label={'Cancel'}
				 />
			</div>
		);
	}
}

const ModelGroupWithValidateResponse = withValidateResponse(ModalGroup)

export default connect(null, {saveItem})(ModelGroupWithValidateResponse)
